import type { CSSProperties } from 'react';

export const s: Record<string, CSSProperties> = {
  container: {
    border: '1px solid #e9ecef',
    borderRadius: '6px',
    backgroundColor: '#fafbfc',
    marginBottom: '6px'
  },
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '6px 10px',
    background: '#f1f3f5',
    borderBottom: '1px solid #e9ecef',
    borderRadius: '6px 6px 0 0',
    cursor: 'pointer',
    userSelect: 'none'
  },
  headerTitle: {
    fontSize: '11px',
    fontWeight: 700,
    color: '#495057',
    textTransform: 'uppercase',
    letterSpacing: '0.06em'
  },
  headerRight: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px'
  },
  chevron: {
    fontSize: '10px',
    color: '#6c757d',
    lineHeight: 1
  },
  body: { padding: '2px 0' },
  row: {
    display: 'flex',
    alignItems: 'center',
    gap: '6px',
    padding: '3px 8px',
    cursor: 'grab'
  },
  rowDragOver: {
    backgroundColor: '#e8f4ff',
    borderTop: '2px solid #4dabf7'
  },
  grabber: {
    flexShrink: 0,
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center'
  },
  chip: { flex: 1, minWidth: 0 },
  scoreCell: { flexShrink: 0 },
  emptyText: {
    fontSize: '11px',
    color: '#adb5bd',
    fontStyle: 'italic',
    padding: '6px 10px',
    display: 'block'
  },
  popoverBackdrop: {
    position: 'fixed',
    inset: 0,
    zIndex: 1000
  },
  popover: {
    position: 'fixed',
    zIndex: 1001,
    background: '#fff',
    border: '1px solid #e9ecef',
    borderRadius: '8px',
    boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
    padding: '12px',
    minWidth: '260px',
    maxWidth: '320px',
    maxHeight: '400px',
    overflowY: 'auto'
  }
};
